// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Link } from 'react-router-dom';

// import SIPCalculator from '../components/Calculators/SIPCalculator';
// import LumpsumCalculator from '../components/Calculators/LumpsumCalculator';
// import SWPCalculator from '../components/Calculators/SWPCalculator';
// import RetirementCalculator from '../components/Calculators/RetirementCalculator';
// import ChildEducationCalculator from '../components/Calculators/ChildEducationCalculator';
// import MarriageCalculator from '../components/Calculators/MarriageCalculator';
// import HomeLoanCalculator from '../components/Calculators/HomeLoanCalculator';
// import StepUpSIPCalculator from '../components/Calculators/StepUpSIPCalculator';
// import ComboCalculator from '../components/Calculators/ComboCalculator';

// import {
//   FaArrowRight,
//   FaWhatsapp,
//   FaChartLine,
//   FaShieldAlt,
//   FaCalculator,
//   FaCheckCircle,
// } from 'react-icons/fa';

// const Calculators = () => {
//   const [activeCalculator, setActiveCalculator] =
//     useState('sip');

//   const calculators = [
//     {
//       id: 'sip',
//       name: 'SIP Calculator',
//       icon: '📈',
//       description:
//         'Calculate SIP returns with inflation adjustment',
//       component: SIPCalculator,
//       color: 'from-blue-500 to-blue-600',
//     },

//     {
//       id: 'stepup',
//       name: 'Step-Up SIP',
//       icon: '📊',
//       description:
//         'Increase SIP annually for higher wealth creation',
//       component: StepUpSIPCalculator,
//       color: 'from-indigo-500 to-indigo-600',
//     },

//     {
//       id: 'lumpsum',
//       name: 'Lumpsum',
//       icon: '💰',
//       description:
//         'One-time investment future value planning',
//       component: LumpsumCalculator,
//       color: 'from-green-500 to-green-600',
//     },

//     {
//       id: 'swp',
//       name: 'SWP',
//       icon: '💵',
//       description:
//         'Regular withdrawal and passive income planning',
//       component: SWPCalculator,
//       color: 'from-emerald-500 to-emerald-600',
//     },

//     {
//       id: 'retirement',
//       name: 'Retirement',
//       icon: '👴',
//       description:
//         'Retirement corpus planning with inflation',
//       component: RetirementCalculator,
//       color: 'from-purple-500 to-purple-600',
//     },

//     {
//       id: 'education',
//       name: 'Child Education',
//       icon: '📚',
//       description:
//         'Estimate future education expenses accurately',
//       component: ChildEducationCalculator,
//       color: 'from-pink-500 to-pink-600',
//     },

//     {
//       id: 'marriage',
//       name: 'Marriage',
//       icon: '💒',
//       description:
//         'Plan future marriage expenses smartly',
//       component: MarriageCalculator,
//       color: 'from-rose-500 to-rose-600',
//     },

//     {
//       id: 'homeloan',
//       name: 'Home Loan',
//       icon: '🏠',
//       description:
//         'Calculate EMI and loan affordability',
//       component: HomeLoanCalculator,
//       color: 'from-orange-500 to-orange-600',
//     },

//     {
//       id: 'combo',
//       name: 'Combo Plan',
//       icon: '🎯',
//       description:
//         'SIP + Lumpsum + SWP complete planning',
//       component: ComboCalculator,
//       color: 'from-cyan-500 to-cyan-600',
//     },
//   ];

//   const ActiveComponent = calculators.find(
//     (c) => c.id === activeCalculator
//   )?.component;

//   return (
//     <>
//       <Helmet>
//         <title>
//           Financial Calculators | SIP, Retirement,
//           EMI & Investment Planning | Wisdom
//           Consultancy
//         </title>

//         <meta
//           name="description"
//           content="Use professional financial calculators for SIP, retirement planning, child education, marriage planning, SWP, home loan EMI, and investment growth."
//         />
//       </Helmet>

//       {/* MAIN SECTION */}
//       <section className="relative overflow-hidden bg-[#f5f7f6] min-h-screen">

//         {/* GRID BACKGROUND */}
//         <div
//           className="absolute inset-0 opacity-40"
//           style={{
//             backgroundImage: `
//               linear-gradient(to right, #d7d7d7 1px, transparent 1px),
//               linear-gradient(to bottom, #d7d7d7 1px, transparent 1px)
//             `,
//             backgroundSize: '42px 42px',
//           }}
//         />

//         {/* BLUR EFFECTS */}
//         <div className="absolute top-0 right-0 w-80 h-80 bg-[#edf3ff] rounded-full blur-3xl opacity-60" />

//         <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#e7f3ea] rounded-full blur-3xl opacity-60" />

//         <div className="container-custom relative z-10 py-20">

//           {/* HERO SECTION */}
//           <div className="text-center max-w-5xl mx-auto mb-16">

//             {/* TOP BADGE */}
//             <motion.div
//               initial={{ opacity: 0, y: 15 }}
//               animate={{ opacity: 1, y: 0 }}
//               className="inline-flex items-center gap-3 bg-white shadow-lg px-6 py-3 rounded-full mb-8 border border-[#e9eef9]"
//             >

//               <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//                 <FaCalculator />
//               </div>

//               <span className="font-semibold text-[#0b1c39]">
//                 Advanced Financial Planning Tools
//               </span>
//             </motion.div>

//             {/* TITLE */}
//             <motion.h1
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//               className="text-5xl md:text-7xl font-extrabold leading-tight text-[#222]"
//             >
//               Smart Financial{' '}
//               <span className="text-[#69bf74]">
//                 Calculators
//               </span>
//             </motion.h1>

//             {/* DESCRIPTION */}
//             <motion.p
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.1 }}
//               className="mt-8 text-lg md:text-xl text-gray-600 leading-9 max-w-4xl mx-auto"
//             >
//               Calculate investment returns,
//               retirement corpus, child education
//               costs, EMI planning, and future
//               financial goals with professional
//               financial tools.
//             </motion.p>

//             {/* FEATURE TAGS */}
//             <div className="flex flex-wrap justify-center gap-4 mt-10">

//               {[
//                 'Inflation Adjustment',
//                 'Retirement Planning',
//                 'EMI Calculation',
//                 'Goal-Based Planning',
//               ].map((item, index) => (
//                 <div
//                   key={index}
//                   className="flex items-center gap-2 bg-white px-5 py-3 rounded-full shadow-sm border border-gray-100"
//                 >
//                   <FaCheckCircle className="text-[#69bf74]" />

//                   <span className="text-sm font-medium text-[#0b1c39]">
//                     {item}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* CALCULATOR NAVIGATION */}
//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">

//             {calculators.map((calc) => (
//               <motion.button
//                 whileHover={{ y: -4 }}
//                 whileTap={{ scale: 0.98 }}
//                 key={calc.id}
//                 onClick={() =>
//                   setActiveCalculator(calc.id)
//                 }
//                 className={`relative overflow-hidden rounded-3xl p-5 text-left border transition-all duration-300 ${
//                   activeCalculator === calc.id
//                     ? 'bg-[#2e56b8] text-white border-[#2e56b8] shadow-2xl'
//                     : 'bg-white border-gray-200 hover:shadow-xl'
//                 }`}
//               >

//                 <div className="flex items-start gap-4">

//                   <div
//                     className={`w-16 h-16 rounded-2xl flex items-center justify-center text-3xl ${
//                       activeCalculator === calc.id
//                         ? 'bg-white/20'
//                         : 'bg-[#edf3ff]'
//                     }`}
//                   >
//                     {calc.icon}
//                   </div>

//                   <div className="flex-1">
//                     <h3 className="text-lg font-bold">
//                       {calc.name}
//                     </h3>

//                     <p
//                       className={`text-sm mt-2 leading-6 ${
//                         activeCalculator === calc.id
//                           ? 'text-white/80'
//                           : 'text-gray-500'
//                       }`}
//                     >
//                       {calc.description}
//                     </p>
//                   </div>
//                 </div>

//                 {activeCalculator === calc.id && (
//                   <div className="absolute top-0 right-0 w-28 h-28 bg-white/10 rounded-full blur-2xl" />
//                 )}
//               </motion.button>
//             ))}
//           </div>

//           {/* ACTIVE CALCULATOR */}
//           <div className="max-w-6xl mx-auto">

//             <AnimatePresence mode="wait">

//               <motion.div
//                 key={activeCalculator}
//                 initial={{ opacity: 0, y: 25 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -25 }}
//                 transition={{ duration: 0.35 }}
//                 className="bg-white rounded-[40px] shadow-[0_20px_60px_rgba(0,0,0,0.08)] p-6 md:p-10 border border-[#e9eef9]"
//               >

//                 {ActiveComponent && (
//                   <ActiveComponent />
//                 )}

//               </motion.div>

//             </AnimatePresence>
//           </div>

//           {/* WHY USE */}
//           <div className="mt-20 grid md:grid-cols-3 gap-8">

//             {[
//               {
//                 icon: <FaChartLine />,
//                 title: 'Accurate Planning',
//                 desc: 'Advanced calculations with inflation adjustment for realistic future planning.',
//               },

//               {
//                 icon: <FaShieldAlt />,
//                 title: 'Secure Financial Future',
//                 desc: 'Understand your future financial needs before investing.',
//               },

//               {
//                 icon: <FaCalculator />,
//                 title: 'Professional Tools',
//                 desc: 'Professional calculators used for investment and retirement planning.',
//               },
//             ].map((item, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 15 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 text-center"
//               >

//                 <div className="w-16 h-16 mx-auto rounded-2xl bg-[#edf3ff] flex items-center justify-center text-[#2e56b8] text-2xl mb-5">
//                   {item.icon}
//                 </div>

//                 <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
//                   {item.title}
//                 </h3>

//                 <p className="text-gray-600 leading-8">
//                   {item.desc}
//                 </p>

//               </motion.div>
//             ))}
//           </div>

//           {/* CTA SECTION */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             className="mt-24"
//           >

//             <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 text-center border border-[#e7f0eb] relative overflow-hidden">

//               {/* BLUR EFFECTS */}
//               <div className="absolute top-0 right-0 w-72 h-72 bg-[#edf3ff] rounded-full blur-3xl opacity-50" />

//               <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#e7f3ea] rounded-full blur-3xl opacity-50" />

//               <div className="relative z-10">

//                 {/* BADGE */}
//                 <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-8">

//                   <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//                     <FaChartLine />
//                   </div>

//                   <span className="font-semibold text-[#0b1c39]">
//                     Expert Financial Consultation
//                   </span>
//                 </div>

//                 {/* TITLE */}
//                 <h2 className="text-4xl md:text-5xl font-bold text-[#222] leading-tight mb-6">

//                   Need Personalized{' '}
//                   <span className="text-[#69bf74]">
//                     Financial Guidance?
//                   </span>

//                 </h2>

//                 {/* DESCRIPTION */}
//                 <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-9 mb-10">

//                   Connect with our financial experts
//                   for investment planning, retirement
//                   strategies, insurance solutions, and
//                   wealth management support.

//                 </p>

//                 {/* BUTTONS */}
//                 <div className="flex flex-col sm:flex-row gap-5 justify-center">

//                   {/* CONTACT BUTTON */}
//                   <Link
//                     to="/contact"
//                     className="inline-flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
//                   >

//                     Schedule Free Consultation

//                     <FaArrowRight />

//                   </Link>

//                   {/* WHATSAPP BUTTON */}
//                   <button
//                     onClick={() =>
//                       window.open(
//                         'https://wa.me/919726344477',
//                         '_blank'
//                       )
//                     }
//                     className="inline-flex items-center justify-center gap-3 bg-[#69bf74] hover:bg-[#58ab63] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
//                   >

//                     <FaWhatsapp />

//                     Chat on WhatsApp

//                   </button>

//                 </div>
//               </div>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Calculators;

import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

import SIPCalculator from '../components/Calculators/SIPCalculator';
import LumpsumCalculator from '../components/Calculators/LumpsumCalculator';
import SWPCalculator from '../components/Calculators/SWPCalculator';
import RetirementCalculator from '../components/Calculators/RetirementCalculator';
import ChildEducationCalculator from '../components/Calculators/ChildEducationCalculator';
import MarriageCalculator from '../components/Calculators/MarriageCalculator';
import HomeLoanCalculator from '../components/Calculators/HomeLoanCalculator';
import StepUpSIPCalculator from '../components/Calculators/StepUpSIPCalculator';
import ComboCalculator from '../components/Calculators/ComboCalculator';

import {
  FaArrowRight,
  FaWhatsapp,
  FaChartLine,
  FaShieldAlt,
  FaCalculator,
  FaCheckCircle,
} from 'react-icons/fa';

const Calculators = () => {
  const [activeCalculator, setActiveCalculator] =
    useState('sip');

  const calculatorContainerRef = useRef(null);

  const calculators = [
    {
      id: 'sip',
      name: 'SIP Calculator',
      icon: '📈',
      description:
        'Calculate SIP returns with inflation adjustment',
      component: SIPCalculator,
      color: 'from-blue-500 to-blue-600',
    },

    {
      id: 'stepup',
      name: 'Step-Up SIP',
      icon: '📊',
      description:
        'Increase SIP annually for higher wealth creation',
      component: StepUpSIPCalculator,
      color: 'from-indigo-500 to-indigo-600',
    },

    {
      id: 'lumpsum',
      name: 'Lumpsum',
      icon: '💰',
      description:
        'One-time investment future value planning',
      component: LumpsumCalculator,
      color: 'from-green-500 to-green-600',
    },

    {
      id: 'swp',
      name: 'SWP',
      icon: '💵',
      description:
        'Regular withdrawal and passive income planning',
      component: SWPCalculator,
      color: 'from-emerald-500 to-emerald-600',
    },

    {
      id: 'retirement',
      name: 'Retirement',
      icon: '👴',
      description:
        'Retirement corpus planning with inflation',
      component: RetirementCalculator,
      color: 'from-purple-500 to-purple-600',
    },

    {
      id: 'education',
      name: 'Child Education',
      icon: '📚',
      description:
        'Estimate future education expenses accurately',
      component: ChildEducationCalculator,
      color: 'from-pink-500 to-pink-600',
    },

    {
      id: 'marriage',
      name: 'Marriage',
      icon: '💒',
      description:
        'Plan future marriage expenses smartly',
      component: MarriageCalculator,
      color: 'from-rose-500 to-rose-600',
    },

    {
      id: 'homeloan',
      name: 'Home Loan',
      icon: '🏠',
      description:
        'Calculate EMI and loan affordability',
      component: HomeLoanCalculator,
      color: 'from-orange-500 to-orange-600',
    },

    {
      id: 'combo',
      name: 'Combo Plan',
      icon: '🎯',
      description:
        'SIP + Lumpsum + SWP complete planning',
      component: ComboCalculator,
      color: 'from-cyan-500 to-cyan-600',
    },
  ];

  const handleCalculatorClick = (calcId) => {
    setActiveCalculator(calcId);
    // Auto scroll to calculator container with smooth behavior
    setTimeout(() => {
      if (calculatorContainerRef.current) {
        const offset = 100; // Offset from top (adjust as needed)
        const elementPosition = calculatorContainerRef.current.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const ActiveComponent = calculators.find(
    (c) => c.id === activeCalculator
  )?.component;

  return (
    <>
      <Helmet>
        <title>
          Financial Calculators | SIP, Retirement,
          EMI & Investment Planning | Wisdom
          Consultancy
        </title>

        <meta
          name="description"
          content="Use professional financial calculators for SIP, retirement planning, child education, marriage planning, SWP, home loan EMI, and investment growth."
        />
      </Helmet>

      {/* MAIN SECTION */}
      <section className="relative overflow-hidden bg-[#f5f7f6] min-h-screen">

        {/* GRID BACKGROUND */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `
              linear-gradient(to right, #d7d7d7 1px, transparent 1px),
              linear-gradient(to bottom, #d7d7d7 1px, transparent 1px)
            `,
            backgroundSize: '42px 42px',
          }}
        />

        {/* BLUR EFFECTS */}
        <div className="absolute top-0 right-0 w-80 h-80 bg-[#edf3ff] rounded-full blur-3xl opacity-60" />

        <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#e7f3ea] rounded-full blur-3xl opacity-60" />

        <div className="container-custom relative z-10 py-20">

          {/* HERO SECTION */}
          <div className="text-center max-w-5xl mx-auto mb-16">

            {/* TOP BADGE */}
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              className="inline-flex items-center gap-3 bg-white shadow-lg px-6 py-3 rounded-full mb-8 border border-[#e9eef9]"
            >

              <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                <FaCalculator />
              </div>

              <span className="font-semibold text-[#0b1c39]">
                Advanced Financial Planning Tools
              </span>
            </motion.div>

            {/* TITLE */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-5xl md:text-7xl font-extrabold leading-tight text-[#222]"
            >
              Smart Financial{' '}
              <span className="text-[#69bf74]">
                Calculators
              </span>
            </motion.h1>

            {/* DESCRIPTION */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="mt-8 text-lg md:text-xl text-gray-600 leading-9 max-w-4xl mx-auto"
            >
              Calculate investment returns,
              retirement corpus, child education
              costs, EMI planning, and future
              financial goals with professional
              financial tools.
            </motion.p>

            {/* FEATURE TAGS */}
            <div className="flex flex-wrap justify-center gap-4 mt-10">

              {[
                'Inflation Adjustment',
                'Retirement Planning',
                'EMI Calculation',
                'Goal-Based Planning',
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 bg-white px-5 py-3 rounded-full shadow-sm border border-gray-100"
                >
                  <FaCheckCircle className="text-[#69bf74]" />

                  <span className="text-sm font-medium text-[#0b1c39]">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* CALCULATOR NAVIGATION */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">

            {calculators.map((calc) => (
              <motion.button
                whileHover={{ y: -4 }}
                whileTap={{ scale: 0.98 }}
                key={calc.id}
                onClick={() =>
                  handleCalculatorClick(calc.id)
                }
                className={`relative overflow-hidden rounded-3xl p-5 text-left border transition-all duration-300 ${
                  activeCalculator === calc.id
                    ? 'bg-[#2e56b8] text-white border-[#2e56b8] shadow-2xl'
                    : 'bg-white border-gray-200 hover:shadow-xl'
                }`}
              >

                <div className="flex items-start gap-4">

                  <div
                    className={`w-16 h-16 rounded-2xl flex items-center justify-center text-3xl ${
                      activeCalculator === calc.id
                        ? 'bg-white/20'
                        : 'bg-[#edf3ff]'
                    }`}
                  >
                    {calc.icon}
                  </div>

                  <div className="flex-1">
                    <h3 className="text-lg font-bold">
                      {calc.name}
                    </h3>

                    <p
                      className={`text-sm mt-2 leading-6 ${
                        activeCalculator === calc.id
                          ? 'text-white/80'
                          : 'text-gray-500'
                      }`}
                    >
                      {calc.description}
                    </p>
                  </div>
                </div>

                {activeCalculator === calc.id && (
                  <div className="absolute top-0 right-0 w-28 h-28 bg-white/10 rounded-full blur-2xl" />
                )}
              </motion.button>
            ))}
          </div>

          {/* ACTIVE CALCULATOR CONTAINER - with ref for scrolling */}
          <div 
            ref={calculatorContainerRef}
            className="max-w-6xl mx-auto"
          >

            <AnimatePresence mode="wait">

              <motion.div
                key={activeCalculator}
                initial={{ opacity: 0, y: 25 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -25 }}
                transition={{ duration: 0.35 }}
                className="bg-white rounded-[40px] shadow-[0_20px_60px_rgba(0,0,0,0.08)] p-6 md:p-10 border border-[#e9eef9]"
              >

                {ActiveComponent && (
                  <ActiveComponent />
                )}

              </motion.div>

            </AnimatePresence>
          </div>

          {/* WHY USE */}
          <div className="mt-20 grid md:grid-cols-3 gap-8">

            {[
              {
                icon: <FaChartLine />,
                title: 'Accurate Planning',
                desc: 'Advanced calculations with inflation adjustment for realistic future planning.',
              },

              {
                icon: <FaShieldAlt />,
                title: 'Secure Financial Future',
                desc: 'Understand your future financial needs before investing.',
              },

              {
                icon: <FaCalculator />,
                title: 'Professional Tools',
                desc: 'Professional calculators used for investment and retirement planning.',
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 text-center"
              >

                <div className="w-16 h-16 mx-auto rounded-2xl bg-[#edf3ff] flex items-center justify-center text-[#2e56b8] text-2xl mb-5">
                  {item.icon}
                </div>

                <h3 className="text-2xl font-bold text-[#0b1c39] mb-4">
                  {item.title}
                </h3>

                <p className="text-gray-600 leading-8">
                  {item.desc}
                </p>

              </motion.div>
            ))}
          </div>

          {/* CTA SECTION */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="mt-24"
          >

            <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 text-center border border-[#e7f0eb] relative overflow-hidden">

              {/* BLUR EFFECTS */}
              <div className="absolute top-0 right-0 w-72 h-72 bg-[#edf3ff] rounded-full blur-3xl opacity-50" />

              <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#e7f3ea] rounded-full blur-3xl opacity-50" />

              <div className="relative z-10">

                {/* BADGE */}
                <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-8">

                  <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                    <FaChartLine />
                  </div>

                  <span className="font-semibold text-[#0b1c39]">
                    Expert Financial Consultation
                  </span>
                </div>

                {/* TITLE */}
                <h2 className="text-4xl md:text-5xl font-bold text-[#222] leading-tight mb-6">

                  Need Personalized{' '}
                  <span className="text-[#69bf74]">
                    Financial Guidance?
                  </span>

                </h2>

                {/* DESCRIPTION */}
                <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-9 mb-10">

                  Connect with our financial experts
                  for investment planning, retirement
                  strategies, insurance solutions, and
                  wealth management support.

                </p>

                {/* BUTTONS */}
                <div className="flex flex-col sm:flex-row gap-5 justify-center">

                  {/* CONTACT BUTTON */}
                  <Link
                    to="/contact"
                    className="inline-flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
                  >

                    Schedule Free Consultation

                    <FaArrowRight />

                  </Link>

                  {/* WHATSAPP BUTTON */}
                  <button
                    onClick={() =>
                      window.open(
                        'https://wa.me/919726344477',
                        '_blank'
                      )
                    }
                    className="inline-flex items-center justify-center gap-3 bg-[#69bf74] hover:bg-[#58ab63] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
                  >

                    <FaWhatsapp />

                    Chat on WhatsApp

                  </button>

                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Calculators;


